const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgDashboardHolding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "40.55mm",
    height: "40.262mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4055 4026.2",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M727.91 8.89l889.86 0 64.74 0 5.15 0 632.69 0 4.97 0 233.09 0 803.82 0c187.16,0 358.71,77.31 483.98,202.24l0 0c124,124 202.25,294.56 202.25,483.98l0 534.69 0 179.11 0 5 0 598 0 5.16 0 79.75 0 1200.94c0,198.97 -81.75,380.3 -213.23,511.97l-2.22 2.14c-131.63,131.52 -312.96,213.27 -511.93,213.27l-815.98 0 -138.59 0 -5.15 0 -632.73 0 -4.96 0 -201.01 0 -835.91 0c-186.93,0 -357.76,-76.93 -482.89,-201.16l-3.2 -3.23c-123.69,-125.05 -200.13,-295.58 -200.13,-481.8l0 -608.05 0 -105.75 0 -5 0 -597.97 0 -5.19 0 -108.83 0 -1171.89c0,-199.05 81.78,-380.38 213.23,-511.97l2.22 -2.15c131.55,-131.48 312.88,-213.26 511.93,-213.26zm0 564.29l954.6 0c89.69,0 163.08,73.4 163.08,163.09l0 1318.34c0,89.69 -73.39,163.08 -163.08,163.08l-954.6 0c-89.69,0 -163.09,-73.39 -163.09,-163.08l0 -1318.34c0,-89.69 73.4,-163.09 163.09,-163.09zm-41.16 2042.91l1036.92 0c67.07,0 121.92,54.85 121.92,121.92l0 600.94c0,67.08 -54.85,121.89 -121.92,121.89l-1036.92 0c-67.08,0 -121.93,-54.81 -121.93,-121.89l0 -600.94c0,-67.07 54.85,-121.92 121.93,-121.92zm1638.57 -2042.91l1036.91 0c67.08,0 121.93,54.85 121.93,121.93l0 600.94c0,67.07 -54.85,121.92 -121.93,121.92l-1036.91 0c-67.08,0 -121.89,-54.85 -121.89,-121.92l0 -600.94c0,-67.08 54.81,-121.93 121.89,-121.93zm41.19 1243.19l954.57 0c89.68,0 163.08,73.39 163.08,163.08l0 1318.31c0,89.72 -73.4,163.08 -163.08,163.08l-954.57 0c-89.72,0 -163.08,-73.36 -163.08,-163.08l0 -1318.31c0,-89.69 73.36,-163.08 163.08,-163.08z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHolding);
export default __webpack_public_path__ + "static/media/dashboardHolding.a60bab26c38e61445989e7a54c954613.svg";
export { ForwardRef as ReactComponent };